export default class EofError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'NotTheRightPdfElementError';
  }
}
